var map = {
	"./aparthotelclub/ic_bookings.png": 82885,
	"./beachful/ic_bookings.png": 12295,
	"./castlepedia/ic_bookings.png": 96438,
	"./cocktayl/ic_bookings.png": 18862,
	"./ic_bookings.png": 65117,
	"./luxresortclub/ic_bookings.png": 34311,
	"./parkful/ic_bookings.png": 91034,
	"./prefabworld/ic_bookings.png": 88332,
	"./rooftopclub/ic_bookings.png": 13615,
	"./spaclub/ic_bookings.png": 78129,
	"./worldcasino/ic_bookings.png": 9777,
	"./zoopedia/ic_bookings.png": 40555
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6166;